module.exports = __webpack_public_path__ + "static/img/baccarat-btn.76e1e86.png";